// extracted by mini-css-extract-plugin
export default {"fallback":"_5DCx9nvz"};